import styled from 'styled-components';

export const EditContainer = styled.div`
  margin-top: 24px;

  & > div:first-child {
    margin-bottom: 16px;
  }
`;
